import { useEHRContext } from 'contexts/EHRContext';
import i18n from 'i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaIdCardAlt, FaLongArrowAltLeft } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
// import { useUserContext } from 'store';
import { formatName, translateGender } from 'utils/AuxiliarFunctions';
import { formatISO2DisplayDateString } from 'utils/dateFunctions';
import { findTabObject, tabsInfo } from 'utils/patientSummary';
import { currentMode, features } from 'configs';

import './ProfileSummaryArea.css';
import { useReportModalContext } from 'contexts/ReportModalContext';

export function ProfileSummaryArea() {
  // const [user] = useUserContext();
  const history = useHistory();
  const { t } = useTranslation('PatientSummary');
  const { ehrState, patientSummary } = useEHRContext();
  const { selectReport } = useReportModalContext();
  const tabsToShowScore = [
    'diagnosis',
    'allergies',
    'medications',
    'examRequests',
    'hospitalizations',
    'procedures',
  ];
  let patientBloodPressureResource;
  let patientWeightResource;
  let patientHeightResource;

  try {
    patientBloodPressureResource = findTabObject({
      patientSummary,
      targetTab: 'bloodPressure',
    }).resource?.entry[0]?.resource;
    patientWeightResource = findTabObject({
      patientSummary,
      targetTab: 'weight',
    }).resource?.entry[0]?.resource;
    patientHeightResource = findTabObject({
      patientSummary,
      targetTab: 'height',
    }).resource?.entry[0]?.resource;
  } catch (err) {
    patientBloodPressureResource = null;
    patientWeightResource = null;
    patientHeightResource = null;
  }

  return (
    <>
      <div className="summaryArea">
        {!features.myReports ? (
          <div className="spaceBetween">
            {<p className="summaryAreaTitle">Registros do paciente</p>}
            {currentMode !== 'aghu' && (
              <button className="returnButton" onClick={() => history.goBack()}>
                <span className="returnButtonIcon">
                  <FaLongArrowAltLeft />
                </span>
                <p className="returnButtonText"> Voltar </p>
              </button>
            )}
          </div>
        ) : (
          <></>
        )}
        <div className="spaceBetweenSummary">
          <div className="profileInfo">
            <FaIdCardAlt className="cardIcon" />
            <div className="personalInfo">
              <p className="personalInfoTitle">
                {formatName(ehrState?.resource.name)}
              </p>
              <div className="displayFlex">
                <p className="personalInfoLabel"> Data de Nascimento: </p>
                <p className="personalInfoData">
                  {ehrState?.resource?.dateOfBirth?.length &&
                  ehrState?.resource.dateOfBirth !== 'Não encontrado'
                    ? formatISO2DisplayDateString(
                        ehrState?.resource.dateOfBirth,
                        i18n.language,
                      )
                    : 'Não encontrado'}
                </p>
              </div>
              <div className="displayFlex">
                <p className="personalInfoLabel"> Sexo:</p>
                <p className="personalInfoData">
                  {translateGender(ehrState?.resource.gender)}
                </p>
              </div>
              <div className="displayFlex">
                <p className="personalInfoLabel"> CNS:</p>
                <p className="personalInfoData">
                  {ehrState?.resource.healthNumber}
                </p>
              </div>
            </div>
          </div>
          {!features.myReports ? (
            <div className="healthScoreBoard">
              {tabsToShowScore.map((targetTab) => {
                const tabResource = findTabObject({
                  patientSummary,
                  targetTab,
                });
                if (tabResource?.resource) {
                  return (
                    <>
                      {tabResource.resource.total !== 0 && (
                        <div className="score">
                          <div>
                            <p>{t(tabsInfo[targetTab].name)}</p>
                            <strong>{tabResource.resource.total}</strong>
                          </div>
                        </div>
                      )}
                    </>
                  );
                }
                return <></>;
              })}
            </div>
          ) : (
            <button className="returnButton" onClick={() => history.goBack()}>
              <span className="returnButtonIcon">
                <FaLongArrowAltLeft />
              </span>
              <p className="returnButtonText"> Voltar </p>
            </button>
          )}
        </div>
        {!features.myReports && (
          <>
            <div>
              <hr className="divisor noMarginTop" />
              <div className="healthInfo">
                <div className="bloodPressure">
                  <div
                    className="healthInfoItem"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      selectReport({
                        idArg:
                          patientBloodPressureResource?.meta?.tag[0]?.code.split(
                            'urn:oid:',
                          )[1],
                        practitioner: 'Não Encontrado',
                        isoDate:
                          patientBloodPressureResource?.effectiveDateTime,
                      })
                    }
                  >
                    <p className="healthInfoItemTitle"> Pressão arterial </p>
                    <p className="healthInfoItemValue">
                      {patientBloodPressureResource?.component[0]?.valueQuantity
                        ?.value || ' - '}
                      /
                      {patientBloodPressureResource?.component[1]?.valueQuantity
                        ?.value || ' - '}{' '}
                      mmhg
                    </p>
                    <p className="healthInfoItemDate">
                      {patientBloodPressureResource?.effectiveDateTime
                        ? formatISO2DisplayDateString(
                            patientBloodPressureResource.effectiveDateTime,
                            i18n.language,
                          )
                        : ' - '}
                    </p>
                  </div>
                </div>
                <div className="patientWeight">
                  <div
                    className="healthInfoItem"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      selectReport({
                        idArg:
                          patientWeightResource?.meta?.tag[0]?.code.split(
                            'urn:oid:',
                          )[1],
                        practitioner: 'Não Encontrado',
                        isoDate: patientWeightResource?.effectiveDateTime,
                      })
                    }
                  >
                    <p className="healthInfoItemTitle"> Peso </p>
                    <p className="healthInfoItemValue">
                      {patientWeightResource?.valueQuantity?.value || ' - '} kg
                    </p>
                    <p className="healthInfoItemDate">
                      {patientWeightResource?.effectiveDateTime
                        ? formatISO2DisplayDateString(
                            patientBloodPressureResource.effectiveDateTime,
                            i18n.language,
                          )
                        : ' - '}
                    </p>
                  </div>
                </div>
                <div className="patientHeight">
                  <div
                    className="healthInfoItem"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      selectReport({
                        idArg:
                          patientHeightResource?.meta?.tag[0]?.code.split(
                            'urn:oid:',
                          )[1],
                        practitioner: 'Não Encontrado',
                        isoDate: patientHeightResource?.effectiveDateTime,
                      })
                    }
                  >
                    <p className="healthInfoItemTitle"> Altura </p>
                    <p className="healthInfoItemValue">
                      {patientHeightResource?.valueQuantity?.value || ' - '} cm
                    </p>
                    <p className="healthInfoItemDate">
                      {patientHeightResource?.effectiveDateTime
                        ? formatISO2DisplayDateString(
                            patientBloodPressureResource.effectiveDateTime,
                            i18n.language,
                          )
                        : ' - '}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="divisor" />
          </>
        )}
      </div>
    </>
  );
}
